// What S4I considers "indefinitely". S4I doesn't have null for all types.
export const HIGH_DATE_S4I = '99991231';
